module.exports = __webpack_public_path__ + "static/CSF5-4144d7ebf5f2102119a02b31f6bc43ba.png";